import { detect } from 'detect-browser';
import { sendEvent } from './add-activity-stream-event';

const browser = detect();
const timestamp = () => new Date().toISOString();

export type ArticleEventParams = {
  sessionId: string;
  sourceApplication: string;
};
const useArticleEvents = ({ sessionId, sourceApplication }: ArticleEventParams) => {
  const partitionKey = sessionId;
  const contentSessionStarted = (
    contentId: string,
    userId: string,
    roles: string[],
    service: string,
    userOrganisations: string[],
  ) =>
    sendEvent({
      partitionKey,
      sourceApplication,
      type: 'ContentSessionStartedEventV1',
      payload: {
        sessionId,
        timestamp: timestamp() as any,
        contentReference: { type: 'Article', id: contentId },
        userIdentity: {
          type: 'User',
          id: userId,
          roles,
          organisations: userOrganisations,
        },
        deviceInfo: {
          type: 'Browser',
          name: browser?.name || 'unknown',
          version: browser?.version || '0.0.0',
        },
        appInfo: {
          type: 'Web',
          version: process.env.PACKAGE_VERSION || '0',
          language: 'sv-SE',
        },
        service,
      },
    });
  const contentSessionEnded = () => {
    sendEvent(
      {
        partitionKey,
        sourceApplication,
        type: 'ContentSessionEndedEventV1',
        payload: { sessionId, timestamp: timestamp() as any },
      },
      true,
    );
  };
  const audioPaused = () => {
    sendEvent({
      partitionKey,
      sourceApplication,
      type: 'AudioPausedEventV1',
      payload: { sessionId, timestamp: timestamp() as any },
    });
  };
  const audioEnded = () => {
    sendEvent({
      partitionKey,
      sourceApplication,
      type: 'AudioEndedEventV1',
      payload: { sessionId, timestamp: timestamp() as any },
    });
  };
  const audioSeeking = (position: number, duration: number) => {
    sendEvent({
      partitionKey,
      sourceApplication,
      type: 'AudioSeekingEventV1',
      payload: { sessionId, timestamp: timestamp() as any, position, duration },
    });
  };
  const audioStarted = () => {
    sendEvent({
      partitionKey,
      sourceApplication,
      type: 'AudioStartedEventV1',
      payload: { sessionId, timestamp: timestamp() as any },
    });
  };
  return {
    contentSessionStarted,
    contentSessionEnded,
    audioPaused,
    audioStarted,
    audioEnded,
    audioSeeking,
  };
};

export default useArticleEvents;
